exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pixel-editor{align-self:stretch;flex-grow:1;background-color:#888;position:relative;width:100%;height:100%;overflow:hidden;touch-action:none}", ""]);

